import React from 'react';
import { IconProps } from './types';

const PhoneCallIcon: React.FC<IconProps> = props => {
  const { height = '24', width = '24' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill="#FFB840" />
      <mask id="mask0_7012_76009" maskUnits="userSpaceOnUse" x="4" y="4" width="16" height="16">
        <rect x="4" y="4" width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_7012_76009)">
        <path
          d="M17.3 18C15.8667 18 14.4696 17.6804 13.1087 17.0413C11.7473 16.4027 10.5418 15.5582 9.492 14.508C8.44178 13.4582 7.59733 12.2527 6.95867 10.8913C6.31956 9.53044 6 8.13333 6 6.7C6 6.5 6.06667 6.33333 6.2 6.2C6.33333 6.06667 6.5 6 6.7 6H9.4C9.55556 6 9.69444 6.05 9.81667 6.15C9.93889 6.25 10.0111 6.37778 10.0333 6.53333L10.4667 8.86667C10.4889 9.02222 10.4862 9.16378 10.4587 9.29133C10.4307 9.41933 10.3667 9.53333 10.2667 9.63333L8.66667 11.2667C9.13333 12.0667 9.71667 12.8167 10.4167 13.5167C11.1167 14.2167 11.8889 14.8222 12.7333 15.3333L14.3 13.7667C14.4 13.6667 14.5307 13.5916 14.692 13.5413C14.8529 13.4916 15.0111 13.4778 15.1667 13.5L17.4667 13.9667C17.6222 14 17.75 14.0749 17.85 14.1913C17.95 14.3082 18 14.4444 18 14.6V17.3C18 17.5 17.9333 17.6667 17.8 17.8C17.6667 17.9333 17.5 18 17.3 18Z"
          fill="white"
        />
      </g>
    </svg>
  );
};
export default PhoneCallIcon;
